import React, { createContext } from 'react';
import { useSelector } from "react-redux";
import { useRouteMatch } from "react-router-dom";

import _ from "lodash";

import { fetchingCustomField, fetchCustomFields, deleteCustomField, createCustomField, updateCustomField, invalidateCustomFields, fetchingPaperfliteCustomFields, createCustomFieldFromPf, fetchingPaperfliteCustomFieldsSync } from 'actions/fields/fields';
import { FieldsView } from 'components/Fields';

import { getBaseUrl } from 'services/util';
import styles from './../../../../components/Fields/fields.module.scss';

export const FieldsContext = createContext();

export default function CustomFieldsView({ hideButtons = false }) {

  let { url } = useRouteMatch();
  let baseUrl = getBaseUrl(url);

  const loading = useSelector((state) => _.get(state, "fields.loading") || false);
  const creating = useSelector((state) => _.get(state, "fields.creating") || false);
  const updating = useSelector((state) => _.get(state, "fields.updating") || false);

  const workspaceId = useSelector((state) => _.get(state, "workspaces.workspace.item.id") || null);
  const storyboardId = useSelector((state) => _.get(state, "storyboards.storyboard.item.id") || null);

  const customFields = useSelector((state) => _.get(state, "fields.items") || []);
  const currentField = useSelector((state) => _.get(state, "fields.currentField") || null);

  const FieldsContextValue = {
    path: `${baseUrl}/storyboards/${storyboardId}/custom-fields/`,
    fetchCustomFields: fetchCustomFields,
    fetchingCustomField: fetchingCustomField,
    createCustomField: createCustomField,
    updateCustomField: updateCustomField,
    deleteCustomField: deleteCustomField,
    fetchingPaperfliteCustomFields, fetchingPaperfliteCustomFieldsSync, createCustomFieldFromPf,
    invalidateCustomFields: invalidateCustomFields,
    entityType: "ASSET"
  }

  return (
    <div className={styles.fieldsSection}>
      <div className={styles.header}>Custom Fields</div>
      <div className={styles.description}>Craft your Custom-made-fields here.</div>
      
      <FieldsContext.Provider value={FieldsContextValue}>
        <FieldsView 
          loading={loading}
          creating={creating}
          updating={updating} 
          storyboardId={storyboardId} 
          workspaceId={workspaceId} 
          customFields={customFields} 
          currentField={currentField} 
          fieldType={"list_field"} 
          entityType={"ASSET"}
          hideButtons={hideButtons}
        />
      </FieldsContext.Provider>
    </div>
  )
}